import Vue from 'vue';
import Router from 'vue-router';
import Location from './Location/Location';
import Keywords from './Keywords/Keywords';
import Finish from './Finish/Finish';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Location',
      component: Location,
    },
    {
      path: '/keywords',
      name: 'Keywords',
      component: Keywords,
    },
    {
      path: '/finish',
      name: 'Finish',
      component: Finish,
    },
  ],
});
